import {createContext} from 'react';

// Zona que se puede abrir a pantalla completa (componentes/zona-ampliable.tsx):
// si esta abierta y como alternarla. La caja de la tabla (caja-ajustable.tsx)
// dibuja el boton justo encima de la tabla y toma mas alto cuando esta abierta.
export type PantallaCompleta = {completa: boolean; alternar?: () => void};
export const ContextoPantallaCompleta = createContext<PantallaCompleta>({completa: false});
